import { render, staticRenderFns } from "./ConfiguracaoUnidadeAdministrativaLocalArmazenamento.vue?vue&type=template&id=30583a40"
import script from "./ConfiguracaoUnidadeAdministrativaLocalArmazenamento.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoUnidadeAdministrativaLocalArmazenamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports